import React, { useEffect, useRef } from "react";
import { CollectContainer } from "./useCollect";
import classNames from "classnames";
import styles from "../components/CardInfoBox/CardInfoBox.module.css";
import CardImage from "assets/Credit_Card_Icon.svg";
import CalendarIcon from "assets/calendar_Icon.svg";
import WarningCardModal from "components/WarningCardModal";
import { useTranslation } from "react-i18next";

export function CollectExample({
  triggerClick,
  onTokenReceived,
  onValidationChange,
  updateCollectValidation,
  forceError = {},
}) {
  const {
    getTokenizationKey,
    fieldInfo,
    cardTypePaymentWarning,
    setCardTypePaymentWarning,
  } = CollectContainer.useContainer();
  const { t } = useTranslation();

  // Use a ref to always have access to the latest onTokenReceived callback
  const onTokenReceivedRef = useRef(onTokenReceived);
  useEffect(() => {
    onTokenReceivedRef.current = onTokenReceived;
  }, [onTokenReceived]);

  useEffect(() => {
    getTokenizationKey
      .mutateAsync((response) => {
        console.log("CollectJS callback triggered with response:", response);
        if (onTokenReceivedRef.current) {
          onTokenReceivedRef.current(response);
        }
      })
      .catch((error) => {
        console.error(t("Error fetching tokenization key"), error);
      });

    return () => {
      if (window.CollectJS) window.CollectJS = null;
    };
  }, []);

  useEffect(() => {
    if (triggerClick) {
      handleCollect();
    }
  }, [triggerClick]);

  useEffect(() => {
    // Simulate validation check
    onValidationChange({
      ccnumberValid: fieldInfo.ccnumber.valid,
      ccexpValid: fieldInfo.ccexp.valid,
    });

    // Update the parent component's validation state
    updateCollectValidation({
      ccnumberValid: fieldInfo.ccnumber.valid,
      ccexpValid: fieldInfo.ccexp.valid,
    });
  }, [fieldInfo.ccnumber.valid, fieldInfo.ccexp.valid]);

  const handleCollect = () => {
    if (
      window.CollectJS &&
      typeof window.CollectJS.startPaymentRequest === "function"
    ) {
      window.CollectJS.startPaymentRequest();
    } else {
      console.error(t("CollectJS is not initialized properly"));
    }
  };

  //Triggers warning message
  const handlePaymentWarningClose = () => {
    setCardTypePaymentWarning(false);
    window.location.reload();
  };

  const containerClass = (field) => {
    const { valid } = fieldInfo[field];
    const isForceError = forceError[field];

    const classes = classNames({
      [styles.containerValid]: valid,
      [styles.containerDefault]: valid === null,
      [styles.containerError]: isForceError || valid === false,
      [styles.card]: true,
    });
    return classes;
  };

  const renderErrorMessage = (field) => {
    const { valid, message } = fieldInfo[field];
    if (message && valid === false) {
      return <div className={styles.errorMsg}>{message}</div>;
    }
    return null;
  };

  return (
    <>
      <div className={styles.container}>
        <div className={containerClass("ccnumber")}>
          <div className={styles.image}>
            <img src={CardImage} alt="Card Icon" />
          </div>
          <div id="ccnumber" className={styles.cardInput}></div>
        </div>
        <div className={containerClass("ccexp")}>
          <div className={styles.image}>
            <img src={CalendarIcon} alt="Calendar Icon" />
          </div>
          <div id="ccexp" className={styles.cardInput}></div>
        </div>
      </div>
      <div className={styles.errorContainer}>
        {renderErrorMessage("ccnumber")}
        {renderErrorMessage("ccexp")}
      </div>

      {cardTypePaymentWarning && (
        <WarningCardModal
          isOpen={cardTypePaymentWarning}
          title={t("Card not accepted")}
          description={""}
          onClick={handlePaymentWarningClose}
        />
      )}
    </>
  );
}

export default CollectExample;
